import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

const setDisplayEditProjectThemeTrayReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<boolean | null>) => {
    if (action.payload === null) {
      state.displayEditProjectThemeTray = !state.displayEditProjectThemeTray;
    } else {
      state.displayEditProjectThemeTray = action.payload;
    }
  });
};

export default setDisplayEditProjectThemeTrayReducer;
